export const iconFontAwesomeHumanitarianPersonArrowUpFromLine = (
	<i className="fa-solid fa-person-arrow-up-from-line"></i>
);
